export default __webpack_public_path__ + "static/media/menu24.3627c91e.svg";